import { format, parseISO } from 'date-fns'
import ptBR from 'date-fns/locale/pt-BR'

export function formatDate(date: string, mask = 'dd/MM') {
  return (date && format(parseISO(date), mask, { locale: ptBR })) || ''
}
